import type { FC, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';

import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';
import { defaultMetadataToColumnSettingMapperV16 } from '@/support/hot-v16';

interface BulkCagesTableV16Props {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetV16Settings;
  innerRef: RefObject<HotTableRef>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  setInvalid: (invalid: boolean) => void;
  maxRows: number;
}

const BulkCagesTableV16: FC<BulkCagesTableV16Props> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  setInvalid,
  maxRows,
}) => {
  return (
    <SpreadsheetV16
      className="pl4 pr4"
      testPrefix="bulk-cages-v16"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      setInvalid={setInvalid}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapperV16}
      maxRows={maxRows}
    />
  );
};

export default BulkCagesTableV16;
